import $ from 'jquery';
import './lib/lightgallery';
import './lib/lg-thumbnail';

const initPhotoGallery = () => {
    const $gallery = $('.cw-photo-gallery .photo-gallery');
    if (!$gallery.length) { return; }

    $gallery.each(function () {
        $(this).lightGallery({ addClass: $(this).hasClass('light-mode') ? 'light-mode' : '' });
    });
};

$(() => {
    initPhotoGallery();
});



// WEBPACK FOOTER //
// ./src/content-widgets/photo-gallery/cw-photo-gallery.js